<template>
  <svg
    :class="className"
    fill="none"
    :height="height"
    viewBox="0 0 24 24"
    :width="width"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M21 12H3M3 12L11.5 3.5M3 12L11.5 20.5" stroke="black" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
  </svg>
</template>

<script>
export default {
  name: 'Back',
  props: {
    width: {
      type: String,
      required: false,
      default: '24'
    },
    height: {
      type: String,
      required: false,
      default: '24'
    },
    className: {
      type: String,
      required: false,
      default: ''
    },
  },
};
</script>